<template>
    <div class="entity-compare">
        <v-row class="entity-compare-header m-0">
            <v-col cols="6" class="header-col left"><h4>Before</h4></v-col>
            <v-col cols="6" class="header-col right"><h4>After</h4></v-col>
        </v-row>
        <v-row class="entity-compare-body m-0">
            <v-col cols="6" class="body-col left">
                <notification-patient-approval-request-form
                    :store="patient"
                    :is-afert="true"
                ></notification-patient-approval-request-form>
            </v-col>

            <v-col cols="6" class="body-col right">
                <notification-patient-approval-request-form
                    :store="patientSnapShot"
                ></notification-patient-approval-request-form>
            </v-col>
        </v-row>
    </div>
</template>
<script>
export default {
    name: 'NotificationApprovalRequest',
    components: {},
    props: {},
    data() {
        return {};
    },
    computed: {
        notification() {
            return this.$store.state.notifications.current;
        },
        patient() {
            return this.$store.state.notification_patient.patient;
        },
        patientSnapShot() {
            return this.$store.state.notification_patient.patientSnapShot;
        },
    },
    watch: {},
    created() {},
    methods: {},
};
</script>
